module.exports = __webpack_public_path__ + "img/luyuanCustomerT4.c012bf5a.png";